<template>
    <v-switch
            v-model="subscribed"
            @change="getNotificationPermission()"
            hide-details
            label=" Ειδοποιήσεις"
    />
</template>

<script>
    import firebaseMixin from "../mixins/firebaseMixin";

    export default {
        name: "EnableNotifications",
        mixins:[firebaseMixin]
    }
</script>

<style scoped>

</style>
